//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from '@/mixins'

import indexFooter from './components/indexFooter'
import { MainApi } from '@/api'
import BScroll from '@better-scroll/core'
import Pullup from '@better-scroll/pull-up'
import PullDown from '@better-scroll/pull-down'
import Util from '@/common/js/util'

// import axios from 'axios'
// import Common from './../common/js/common'

export default {
  name: 'myPlan',
  mixins: [mixin],
  components: {
    indexFooter,
  },
  data() {
    return {
      // better-scroll滚动组件对象
      bs: null,
      scrollTips: '上拉展示更多',
      isMoreData: true,
      isScrollAllow: true,
      shouyiText: '预计每日收益（元）',
      isno: false,
      listArr: [],
      searchForm: {
        // ProvinceId: '',
        // BankType: '',
        // RiskType: '',
        page: 1,
        pageSize: 10,
        // InvestmentDays: '',
        // money: '',
        // order: 'AnnualizedIncomeMin',
        // sort: 'desc',
      },
      tagArr: [
        '咖啡不用断，衣服继续买，轻松成为人生赢家',
        '稍微削减高开支，就能拥有自己的小套间',
        '勒紧裤腰带，不但减肥还能实现财务自由',
      ],
      commentArr: ['低目标', '合理目标', '高目标'],
      tagName: '',
    }
  },
  created() {
    this.getListFn()
    this.getAssessListFn()
    // this.scrollBottomFn()
  },
  mounted() {
    this.initBScroll()
  },
  beforeDestroy() {},
  methods: {
    // getIpFn() {},
    bodyTouchmoveFn(e) {
      e.preventDefault()
    },
    getCommentTipsFn(num) {
      return Util.getCommentTipsFn()[num]
    },

    getListFn() {
      if (this.searchForm.page == 1) {
        this.scrollTips = '上拉展示更多'
        this.isMoreData = true
      }
      if (!this.isMoreData) {
        this.scrollTips = '没有了~'
        this.bs.closePullUp()
        return false
      }
      this.$vux.loading.show({
        text: '加载中',
      })
      MainApi.getUserDepositPlanList(this.searchForm)
        .then(data => {
          this.$vux.loading.hide()
          this.isScrollAllow = true
          if (data.Status === 200) {
            // //console.log('搜索数据 ', data)
            if (this.searchForm.page < 2) {
              // this.isMoreData = true
              this.listArr = data.Result.data
              this.$nextTick(() => {
                //console.log('更新下')

                this.bs.refresh()
              })
            } else {
              if (!data.Result.data.length) {
                // this.$vux.toast.text('没有更多数据了', 'top')
                this.scrollTips = '没有了~'
                this.isMoreData = false
                this.bs.closePullUp()
                return false
              }
              this.listArr = this.listArr.concat(data.Result.data)
              this.$nextTick(() => {
                this.bs.refresh()
              })
              this.scrollTips = '上拉展示更多'
            }
            if (data.Result.count > this.listArr.length) {
              this.bs.openPullUp()
              this.scrollTips = '上拉展示更多'
            } else {
              this.scrollTips = '没有了~'
            }
          } else {
            this.$vux.toast.text(data.Result.ErrorMsg, 'top')
          }
        })
        .catch(() => {
          this.$vux.loading.hide()
        })
    },
    initBScroll() {
      BScroll.use(Pullup)
      BScroll.use(PullDown)

      this.bs = new BScroll(this.$refs.scroll, {
        scrollY: true, // 开启纵向滚动
        click: true, // 允许点击事件
        eventPassthrough: 'horizontal', // 保留横向的原生滚动
        bounce: {
          // 边缘回弹
          top: false,
          bottom: true,
        },
        probeType: 3, // 实时派发 scroll 事件
        pullUpLoad: true, // 开启上拉加载
        pullDownRefresh: false, // 开启下拉刷新
      })
      // //console.log('this.bs', this.bs)

      this.bs.on('pullingUp', () => {
        //console.log('开始上拉')

        this.scrollTips = '正在加载...'
        this.isScrollAllow = false
        this.searchForm.page++
        this.$nextTick(() => {
          this.getListFn()
          this.bs.finishPullUp()
        })
      })
    },
    addPlanBtn() {
      this.$router.push('addPlan')
      // if (this.getArchives) {
      //   this.$router.push('riskTest')
      // } else {
      //   this.$router.push('addPlan')
      // }
    },
    getAssessListFn() {
      MainApi.getRiskAssessmentList()
        .then(data => {
          this.$vux.loading.hide()
          if (data.Status === 200) {
            //console.log('data', data)
            if (data.Result) {
              this.$store.commit('editStateFn', {
                field: 'Archives',
                val: data.Result.Type,
              })
              localStorage.setItem('Archives', data.Result.Type)
              this.tagName = Util.getTagArrFn()[data.Result.Type - 1]
            }
          } else {
            this.$vux.toast.text(data.Result.ErrorMsg, 'top')
          }
        })
        .catch(() => {
          this.$vux.loading.hide()
        })
    },
    lookDetailsFn(id) {
      this.$router.push({
        path: 'planResult',
        query: { id: id },
      })
    },
    GoToTestFn() {
      this.$router.push('riskTest')
    },
  },
  computed: {
    getArchives() {
      return this.$store.state.Archives
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/myPlan.vue